/* Terrasola theme.js */
document.addEventListener('DOMContentLoaded', function () {
  /* Cart AJAX */
  const form = document.getElementById('ts-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(r => r.json())
        .then(data => { updateCartCount(); showToast(data.product_title); })
        .catch(console.error);
    });
  }
  function updateCartCount() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      let badge = document.querySelector('.ts-cart-badge');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ts-cart-badge';
          const cartLink = document.querySelector('.ts-cart-link');
          if (cartLink) cartLink.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) { badge.remove(); }
    });
  }
  function showToast(title) {
    let t = document.getElementById('ts-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ts-toast';
      Object.assign(t.style, { position:'fixed', bottom:'2rem', right:'2rem', zIndex:'999', background:'#2c2c1a', color:'#d4c9a8', padding:'1rem 1.5rem', borderRadius:'4px', fontFamily:"'Jost',sans-serif", fontSize:'13px', borderLeft:'3px solid #8a9e4a', maxWidth:'300px', boxShadow:'0 4px 20px rgba(0,0,0,0.3)', transition:'opacity 0.3s' });
      document.body.appendChild(t);
    }
    t.textContent = '🌿 ' + title + ' added to cart!';
    t.style.opacity = '1';
    clearTimeout(t._timer);
    t._timer = setTimeout(() => { t.style.opacity = '0'; }, 3000);
  }
  window.tsThumbSwitch = function (el, src) {
    const main = document.getElementById('ts-main-img');
    if (main) main.src = src;
    document.querySelectorAll('.ts-product-thumb').forEach(t => t.classList.remove('active'));
    el.classList.add('active');
  };
  window.tsQty = 1;
  window.tsAdjustQty = function (delta) {
    window.tsQty = Math.max(1, window.tsQty + delta);
    const d = document.getElementById('ts-qty-display');
    const i = document.getElementById('ts-qty-input');
    if (d) d.textContent = window.tsQty;
    if (i) i.value = window.tsQty;
  };
  window.tsSelectOption = function (btn) {
    btn.closest('.ts-size-row').querySelectorAll('.ts-size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  };
});
